angular.module('tgaAdmin')
  .controller('HubCopySubdomainModalController', [
    '$scope', '$state', '$window', '$uibModalInstance', '$uibModalStack',
    '$filter', 'userService', 'gameService', 'extras', 'domainService',
    function (
      $scope, $state, $window, $uibModalInstance, $uibModalStack,
      $filter, userService, gameService, extras, domainService,
    ) {
      $scope.data = {
        alerts: [],
        closeButton: true,
        domains: [],
        domain: null, // current domain
        canSubmit: true, // unless destination domain doesnt have arcades sub
        subscriptionMessage: $filter('translate')('modal.copy_hub_subdomain.sub_error'),
        errorMessage: '', // currently only ever filled with subscriptionMessage, but leaving this separate in case of additional errors
      };

      $scope.viewmodel = {
        domain: null, // the domain chosen by the user in this modal
      };

      $scope.initialize = function () {
          domainService.getUserDomainsHavingArcades().then((domains) => {
            if (domains) {
              domains.forEach((domain) => {
                const domainObj = {
                  name: `${domain.name}${
                    domain.name === $scope.data.domain ? ' (current)' : ''
                  }`,
                  domain_id: domain.domain_id,
                  copyable: !!domain.copyable,
                };

                $scope.data.domains.push(domainObj);

                // Set the current domain as the selected one
                if (domain.name === $scope.data.domain) {
                  $scope.viewmodel.domain = domainObj;
                }
              })
            }
          });
        $scope.data.domain = extras.domain;
      };

      $scope.actions = {
        submit(form) {
          form.submitted = true;

          $scope.data.alerts = [];

          if (form.$invalid) {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> ${$filter('translate')('check_form_for_errors')}`,
              'danger',
            );
            return;
          }

          $scope.data.closeButton = false;
          $scope.processing = true;
          $scope.processing = false;
          $uibModalInstance.close($scope.viewmodel.domain);
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        close() {
          $uibModalInstance.dismiss();
        },
        checkDomainValid(form) {
          let valid = true;
          const chosenDomain = $scope.viewmodel.domain;
          if (chosenDomain && !chosenDomain.copyable) {
            valid = false;
            $scope.data.errorMessage = `${$scope.data.subscriptionMessage}`;
          }

          $scope.data.canSubmit = !!valid;
          if (valid) {
            form.domain.$setValidity('required', true);
            $scope.data.errorMessage = '';
          } else {
            form.domain.$setValidity('required', false);
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${$scope.data.errorMessage}`,
              'danger',
            );
          }
        },
      };
      $scope.initialize();
    },
  ]);
